import { UntypedFormGroup } from '@angular/forms';
import {
  NextDisplayView,
  PageHeader
} from '../../login-authentication-screen/models/login-credentials.interface';

export interface AddEmailAddressContent {
  formGroup: UntypedFormGroup;
  formAttributes: AddEmailFormAttributes;
  pageContent: AddEmailPageContent;
  isSuccess?: boolean;
  isError?: boolean;
  message?: string;
}

export interface AddEmailPageContent {
  emailLabel: string;
  confirmEmailLabel: string;
  contentBodyHeader: string;
  headerSubTitle: string;
  headerTitle: string;
  buttonLabel: string;
  nextDisplayView: NextDisplayView;
  viewName: string;
  pageHeader: PageHeader;
  errors: AddEmailErrorMessages;
}

export interface AddEmailFormAttributes {
  errorCount: number;
  errorAlertBanner: boolean;
  emailControlTouched: boolean;
  confirmEmailControlTouched: boolean;
  disableActionButton?: boolean;
  submitAttempt?: boolean;
}

export interface AddEmailErrorMessages {
  emailErrorMessage: Record<string, string>;
  confirmEmailErrorMessage: Record<string, string>;
  alertWarning: string;
}

export type OverlayMessage = { isSuccess: boolean; isError: boolean };
